import { Typography } from '@mui/material';

export function NotFoundPage() {
  return (
    <Typography>Sorry, you've found a bad URL. Perhaps this page has been deleted, but it ain't here now.</Typography>
  );
}
